/**
 * Shared human-scale layout for the electrical garage workshop.
 *
 * Metric meters. Spawn faces −Z toward the training control panel.
 * Origin-centered xz; locomotion clamps to {@link WORKSHOP_SIZE}.
 *
 * The room itself is the experiment (“Power the Room”) — no walk-up lab tables.
 */

export const WORKSHOP_SIZE = {
  width: 8.5,
  depth: 7.0,
  height: 3.0,
} as const;

/** Comfortable standing work-surface height (shelf / apron). */
export const BENCH_TOP_Y = 0.95;

/** Floor stand-zone offset in front of a wall-mounted work surface. */
export const STAND_ZONE_FORWARD = 1.05;

/**
 * Outlet Assembly — left-wall exposed repair bay (not a concept table).
 * `yaw` maps local +Z into the aisle (world +X) so relative prop layout in
 * `station.ts` still faces the learner.
 */
export const OUTLET_BENCH = {
  x: -WORKSHOP_SIZE.width / 2 + 0.32,
  y: BENCH_TOP_Y,
  z: 0.85,
  yaw: Math.PI / 2,
} as const;

/**
 * Low-voltage training control panel — −Z wall, standing reach.
 * Apron center; terminals sit on the shelf, cabinet against the wall.
 */
export const PANEL = {
  x: 0,
  y: 1.08,
  z: -WORKSHOP_SIZE.depth / 2 + 0.4,
} as const;

/** Workshop identity sign — high on the −Z feature wall. */
export const SIGN = {
  x: 0,
  y: 2.28,
  z: -WORKSHOP_SIZE.depth / 2 + 0.05,
} as const;

/** Pedestal fan — far-right corner when facing −Z. */
export const FAN = {
  x: WORKSHOP_SIZE.width / 2 - 0.85,
  y: 0,
  z: -WORKSHOP_SIZE.depth / 2 + 0.78,
} as const;

/** LIGHT B wall switch — left wall, typical switch height. */
export const SWITCH = {
  x: -WORKSHOP_SIZE.width / 2 + 0.045,
  y: 1.18,
  z: -1.35,
} as const;

/** Utility duplex — left wall, between switch and repair bay. */
export const OUTLET_A = {
  x: -WORKSHOP_SIZE.width / 2 + 0.045,
  y: 1.02,
  z: -0.42,
} as const;

/** Shop fixture over the panel / center (LIGHT A). */
export const CEILING_LIGHT_A = {
  x: 0,
  y: WORKSHOP_SIZE.height - 0.2,
  z: -1.35,
} as const;

/** Shop fixture over the left bay (LIGHT B). */
export const CEILING_LIGHT_B = {
  x: -1.7,
  y: WORKSHOP_SIZE.height - 0.2,
  z: 1.05,
} as const;

/** Bulkhead sconce on the right wall. */
export const WALL_LIGHT = {
  x: WORKSHOP_SIZE.width / 2 - 0.07,
  y: 2.02,
  z: -0.35,
} as const;
